/* Jalecos Mania — comportamento do drawer mobile do cabeçalho:
   abre/fecha o menu hambúrguer + alterna as abas Feminino/Masculino. */
(function () {
  var toggle = document.querySelector('.jm-header__menu-toggle');
  var drawer = document.querySelector('[data-jm-drawer]');
  var backdrop = document.querySelector('[data-jm-drawer-backdrop]');
  if (!toggle || !drawer) return;

  function open() {
    drawer.classList.add('is-open');
    drawer.setAttribute('aria-hidden', 'false');
    toggle.setAttribute('aria-expanded', 'true');
    if (backdrop) {
      backdrop.hidden = false;
      requestAnimationFrame(function () { backdrop.classList.add('is-open'); });
    }
    document.documentElement.style.overflow = 'hidden';
  }

  function close() {
    drawer.classList.remove('is-open');
    drawer.setAttribute('aria-hidden', 'true');
    toggle.setAttribute('aria-expanded', 'false');
    if (backdrop) {
      backdrop.classList.remove('is-open');
      setTimeout(function () { backdrop.hidden = true; }, 360);
    }
    document.documentElement.style.overflow = '';
  }

  toggle.addEventListener('click', open);
  drawer.querySelectorAll('[data-jm-drawer-close]').forEach(function (b) {
    b.addEventListener('click', close);
  });
  if (backdrop) backdrop.addEventListener('click', close);
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && drawer.classList.contains('is-open')) close();
  });

  // ===== Mega menu: toque (tablet) e teclado =====
  // No desktop com mouse o hover cuida de tudo (CSS). Em telas de toque com o
  // nav visível, o 1º toque abre o painel e o 2º navega; tocar fora fecha.
  var megaItems = document.querySelectorAll('[data-jm-mega-item]');
  if (megaItems.length) {
    var closeAllMega = function (except) {
      megaItems.forEach(function (item) {
        if (item === except) return;
        item.classList.remove('is-open');
        var l = item.querySelector('.jm-header__nav-link--parent');
        if (l) l.setAttribute('aria-expanded', 'false');
      });
    };

    megaItems.forEach(function (item) {
      var link = item.querySelector('.jm-header__nav-link--parent');
      if (!link) return;

      // toque: só intercepta se veio de pointer "touch" (mouse segue o hover)
      var lastPointerType = '';
      link.addEventListener('pointerdown', function (e) {
        lastPointerType = e.pointerType || '';
      });
      link.addEventListener('click', function (e) {
        if (lastPointerType !== 'touch') return;
        if (!item.classList.contains('is-open')) {
          e.preventDefault();
          closeAllMega(item);
          item.classList.add('is-open');
          link.setAttribute('aria-expanded', 'true');
        }
        // já aberto: deixa o clique navegar normalmente
      });

      // aria-expanded acompanha o hover do mouse também
      item.addEventListener('mouseenter', function () {
        link.setAttribute('aria-expanded', 'true');
      });
      item.addEventListener('mouseleave', function () {
        item.classList.remove('is-open');
        link.setAttribute('aria-expanded', 'false');
      });
    });

    document.addEventListener('click', function (e) {
      if (!e.target.closest || !e.target.closest('[data-jm-mega-item]')) closeAllMega(null);
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') closeAllMega(null);
    });
  }

  // abas Feminino / Masculino — alterna qual menu aparece
  var tabs = drawer.querySelectorAll('[data-jm-gender]');
  var panels = drawer.querySelectorAll('[data-jm-gender-panel]');
  tabs.forEach(function (tab) {
    tab.addEventListener('click', function () {
      var g = tab.getAttribute('data-jm-gender');
      tabs.forEach(function (t) {
        var on = t === tab;
        t.classList.toggle('is-active', on);
        t.setAttribute('aria-selected', on ? 'true' : 'false');
      });
      panels.forEach(function (p) {
        p.hidden = p.getAttribute('data-jm-gender-panel') !== g;
      });
    });
  });
})();
